import { booleanAttribute } from "#ce/utils/props";

export const props = Object.freeze({
  /**
   * Render the divider as a vertical rule instead of a horizontal one.
   *
   * @type {Boolean|String}
   * @default false
   */
  vertical: booleanAttribute(),
  /**
   * Rendered tag. Defaults to `<hr>`; override with `"div"` to drop the semantic horizontal-rule role when the divider is purely decorative.
   *
   * @type {String}
   * @default "hr"
   */
  tag: {
    type: String,
    default: "hr",
  },
});
